/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InstructorEntity = {
    id: string;
    organizationId: string | null;
    createdAt: string;
    updatedAt: string;
    pronouns: InstructorEntity.pronouns | null;
    bio: string | null;
    handle: string | null;
    firstName: string;
    lastName: string;
    stripePaymentProfileId: string | null;
    customerId: string | null;
    archived: boolean;
    testMode: boolean;
    legalName: string | null;
    avatarMediaImageId: string | null;
};
export namespace InstructorEntity {
    export enum pronouns {
        HE_HIM = 'HE_HIM',
        SHE_HER = 'SHE_HER',
        THEY_THEM = 'THEY_THEM',
        NONE = 'NONE',
    }
}

